import { NgModule } from '@angular/core';
import { UnauthorizedComponent } from './unauthorized.component';

@NgModule({
  declarations: [UnauthorizedComponent],
})
export class UnauthorizedModule {}
